import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs, Base_url_imggg, Base_url_bbbslive, Base_url_api_live } from "../config";
import { useNavigate } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { FaTrash, FaTimes, FaUpload, FaPlus } from "react-icons/fa"; // Import icons from react-icons

let Homepage = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();

  useEffect(() => {
    Start();
    Payment();
    GetLeave()
  }, []);

  let [fastag, setFastag] = useState(0)
  let [eel, setEel] = useState(0)
  let [ccc, setccc] = useState(0)
  let [predata, setpredata] = useState(0)
  let [insu, setInsu] = useState([])
  const [ggs, setGgs] = useState([]);
  let [leave, setLeave] = useState()
  let [leavedats, setLeavedatas] = useState()
  let [removeleaves, setRemoveleaves] = useState()

  let [post, setPost] = useState()

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let Payment = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbslive + '/saveuser/getbanner',
        data: {
          data: data,
        },
      })
        .then((dat) => {
          console.log(dat.data, 'kkkkkkkkkkkkkkkkkkkkkk')
          setPost(dat.data)
          setGgs(dat.data.data.bannerImg.imgs)

        })
        .catch((ee) => { });
    } catch (err) { }
  };

  let GetLeave = async () => {
    try {
      let token = await localStorage.getItem("token");
      if (token === undefined || token === null || token === "") {
        navigate("/login");
        return;
      }
      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "get",
        url: Base_url_api_live + '/admin2/getleave',
      })
        .then((dat) => {
          console.log(dat.data, 'Jsson')
          setLeavedatas(JSON.stringify(dat.data.data))
        })
        .catch((ee) => {

        });
    } catch (err) {

    }
  }
  let ClickCat = (re) => {
    console.log(re, "rrrrrrrrrrrrrr");
    navigate("/category", { state: re });
  };

  let clickedit = (re) => {
    console.log(re, "ggggggggggggggggggggg");
    navigate("/editbbps", { state: re });
  }


  const handleImageUpload = async (event) => {

    console.error("Failed to upload image to S3");
    const files = Array.from(event.target.files);
    setGgs([]);

    if (files.length > 0) {
      for (let file of files) {
        try {
          const formData = new FormData();
          formData.append('file', file);

          const uploadResponse = await axios({
            method: "post",
            url: 'https://web.xopay.in/bbps/api/transactionstatus/fileUpload',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          if (uploadResponse.data.status && uploadResponse.data.url) {
            let s3Url = uploadResponse.data.url;
            console.log(s3Url, "Uploaded to S3");

            // If you want to store multiple image URLs, consider using an array
            setGgs(prev => [...prev, s3Url]);


          } else {
            console.error("Failed to upload image to S3");
          }
        } catch (error) {
          console.error("Error uploading image to S3:", error);
        }
      }




    }
  };



  let uploadbanner = async () => {

    console.log(ggs, 'gggggggggggggggggggggg')


    if (ggs === '' || ggs === undefined || ggs === null) {
      alert('Please upload image')
      return
    }

    let pp = { img: ggs }

    let apicall = await axios({
      method: 'post',
      url: Base_url_bbbslive + '/saveuser/uploadbanner',
      data: { pp }
    })
      .then((dat) => {
        console.log(dat.data, 'Jsson')
        Payment()
      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      })
  }


  let uploadleave = async () => {

    console.log(leave, 'leave')

    if (leave === '' || leave === undefined || leave === null) {
      alert('Please upload leave data')
      return
    }

    let pp = { leavedata : leave }

    let apicall = await axios({
      method: 'post',
      url: Base_url_api_live + '/admin2/uploadleave',
      data: pp
    })
      .then((dat) => {
        console.log(dat.data, 'Jsson')
        GetLeave()
      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      })
  }


  let removeleave = async() => {
    console.log(removeleaves, 'leave')

    if (removeleaves === '' || removeleaves === undefined || removeleaves === null) {
      alert('Please upload leave data')
      return
    }

    let pp = { leavedata : removeleaves }

    let apicall = await axios({
      method: 'post',
      url: Base_url_api_live + '/admin2/removeleave',
      data: pp
    })
      .then((dat) => {
        console.log(dat.data, 'Jsson')
        GetLeave()
      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      })
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-8" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }} >
          <div className="row mt-4">
            <p>Master</p>



            <Tabs>
              <TabList>
                <Tab>Banner</Tab>
                <Tab>Holiday</Tab>
              </TabList>

              <TabPanel>
                <div className="position-relative" style={{ width: '100%' }}>

                  <div className="row" >
                    {
                      ggs?.map((rrr, key) => {
                        return (
                          <div className="col-3" >
                            <img
                              src={Base_url_imggg + rrr}
                              // alt={finedata[key].name}
                              className="img-fluid rounded"
                              style={{}}
                            />
                          </div>
                        )
                      })

                    }


                  </div>

                  <label className="btn btn-outline-secondary mt-4">
                    <FaUpload />
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageUpload}
                      style={{ display: "none" }}
                    />
                  </label>


                  <button
                    className=""
                    onClick={() => {
                      // User();
                      uploadbanner()
                    }}
                    style={{ marginLeft: "30%" }}
                  >
                    Submit
                  </button>
                </div>
              </TabPanel>
              <TabPanel>
                <p>Current Holiday list</p>


                <div
                  style={{
                    width: '100%',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    overflow: 'hidden',
                  }}
                >
                  <p
                    style={{
                      fontWeight: '700',
                      whiteSpace: 'normal', // allow text to wrap
                    }}
                    className="mt-3"
                  >
                    {leavedats}
                  </p>
                </div>




                <div className="row" >
                  <div className="col-6" >
                    <p>Upload leave</p>
                    <textarea
                    placeholder="23/11/2025"
                      type="text"
                      onChange={(e) => {
                        setLeave(e.target.value)
                      }}
                      className="form-control"
                    />
                    <button
                      className="mt-2"
                      onClick={() => {
                        // User();
                        uploadleave()
                      }}
                    >
                      Submit
                    </button>
                  </div>
                  <div className="col-6" >
                    <p>Remove leave</p>
                    <textarea
                      type="text"
                      onChange={(e) => {
                        setRemoveleaves(e.target.value)
                      }}
                      className="form-control"
                    />
                    <button
                      className="mt-2"
                      onClick={() => {
                        // User();
                        removeleave()
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>




              </TabPanel>
            </Tabs>





          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
